module.exports = __webpack_public_path__ + "img/Satellite.dd91ebc9.png";